app.controller('ProductsController', ['$scope','Config','$timeout','cart','toaster','product','CacheFactory','helper', function($scope,Config,$timeout,cart,toaster,product,CacheFactory,helper){

	//if no category layout type stored in local storage set the details to grid
	if(!angular.isDefined(CacheFactory.get('appCache').get('categoryLayout'))){
		CacheFactory.get('appCache').put('categoryLayout','grid');
	}

	$scope.categoryLayout = CacheFactory.get('appCache').get('categoryLayout');
	$scope.products = [];
	$scope.productService = product;
	$scope.base_url = Config.base_url;
	$scope.totalItems = 0;
  	$scope.currentPage = 1;
  	$scope.perPage = 120; //was 12
  	$scope.searchTerm = '';
  	$scope.cartService = cart;

	$scope.init = function(){
		$scope.getProducts();
	}

	$scope.pageChanged = function(page){
		helper.showLoader();
		$scope.currentPage = page;
		$scope.products = [];
		$scope.getProducts();
	}

	$scope.getProducts = function(){
		width = 300;
		height = 300;
		sectionType = angular.element('#sectionType').val();

		$scope.productService.getProducts(sectionType,width,height,$scope.currentPage,$scope.perPage).then(function(response) {
		   	if (sectionType == "search") {
				$scope.products = response.data;
			  } else {
				$scope.products = response.data.paginator.data;
			  }
		   	angular.forEach($scope.products, function(product, key) {
				product.qty = 1;
			});
		   	$scope.totalItems = response.data.total;
		   	$scope.perPage = response.data.per_page;
		   	$scope.currentPage = response.data.current_page;
		   	$timeout(function () {
		   		helper.hideLoader();
			}, 100);
		  }, function(response) {
		    console.log(response);
		  });
	}

	$scope.switchLayout = function(current,other){
		$scope.categoryLayout = current;
		CacheFactory.get('appCache').put('categoryLayout',current);
	}

	$scope.cartAdd = function(productIdx,qty){
		//get product from the group
		cart.add($scope.products[productIdx],qty);
		$('#quoteModal').modal('show');
	}

	$scope.lowestPrice = function(product,discount){
		//check if there is price breaks
		if(product.price_breaks.length>0){
			//if yes then get the lowest one
			return (Object.values(product.price_breaks).reverse())[0].price;
		}else{
			//if no then return the normal price
			if(discount){
				return product.discounted_price;
			}else{
				return product.price;
			}
		}
	}

}]);